// client/src/components/PayPalDonation.jsx
import React from "react";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";

const PayPalDonation = ({ clientId, currency = "USD", amount = "10.00" }) => {
    return (
        <PayPalScriptProvider
            options={{
                "client-id": clientId,
                currency: currency,
            }}
        >
            <div className="paypal-donation-container">
                <h2 className="text-center text-red-700 text-3xl font-bold mb-6">Donate with PayPal</h2>
                <PayPalButtons
                    style={{ layout: "vertical" }}
                    createOrder={(data, actions) => {
                        return actions.order.create({
                            purchase_units: [
                                {
                                    amount: {
                                        value: amount, // Set donation amount dynamically
                                    },
                                },
                            ],
                        });
                    }}
                    onApprove={(data, actions) => {
                        return actions.order.capture().then((details) => {
                            alert(
                                `Donation successful! Thank you, ${details.payer.name.given_name}.`
                            );
                        });
                    }}
                    onError={(err) => {
                        console.error("PayPal Checkout Error:", err);
                    }}
                />
            </div>
        </PayPalScriptProvider>
    );
};

export default PayPalDonation;
